// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b3fef437","453":"bb50c7e7","455":"d40c641b","977":"57071279"}[chunkId] + ".chunk.js";
};